import React from 'react';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';
import Pagination from './../../Pagination';
import { dateToTimezone, empty } from './../../../utils';

const Table = React.memo((props) => {
    let permissions = [];
    if (props.user && props.user.uth_permissions != null) {
        permissions = JSON.parse(props.user.uth_permissions);
    }

    const handleShowFormModal = (id) => {
        props.setIdModal(id);
        props.setRequest(id);
        props.showFormModal();
    };

    const renderRequests = () => {
        if (props.fetching) {
            return (
                <tr>
                    <td colSpan="10"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (props.requests.length === 0) {
            return (
                <tr>
                    <td colSpan="10">No results</td>
                </tr>
            );
        }

        return props.requests.map((request) => {
            let lastResponseDate = null;
            if (!empty(request.last_response_date)) {
                lastResponseDate = dateToTimezone(request.last_response_date, 'MM/DD/YYYY');
            }

            let status = '';
            if (parseInt(request.status) === 1) {
                status = <td className="open-status">Open</td>;
            } else {
                status = <td className="closed-status">Closed</td>;
            }

            let files = [];
            if (!empty(request.files)) {
                files = JSON.parse(request.files);
            }

            let filesTd = [];
            for (let i = 0; i < files.length; i++) {
                filesTd.push(<div><a href={files[i].url} target="_blank" rel="noopener noreferrer">{files[i].name}</a></div>);
            }

            let sendResponseIcon = null;
            if (permissions.includes('help-desk-response')) {
                sendResponseIcon = (
                    <Tooltip title="Send Response" position="top" arrow size="small" className="action-tooltip">
                        <i className="fas fa-mail-bulk info-icon" onClick={handleShowFormModal.bind(this, request.id)} />
                    </Tooltip>
                );
            }

            return (
                <tr key={request.id}>
                    <td>{request.id}</td>
                    <td>{dateToTimezone(request.created_at, 'MM/DD/YYYY')}</td>
                    <td>{lastResponseDate}</td>
                    <td>{request.name}</td>
                    <td>{request.email}</td>
                    <td>{request.help_with}</td>
                    <td>{filesTd}</td>
                    <td>{request.acm_member}</td>
                    {status}
                    <td>
                        <div className="actions">
                            {sendResponseIcon}
                        </div>
                    </td>
                </tr>
            );
        });
    };

    const handleSort = (column, type) => {
        props.setSort(column, type);
    };

    const renderHeader = (label, field) => {
        let sortType = 'asc';
        let sortIcon = <i className="fas fa-sort" />;
        if (props.sort.column === field) {
            if (props.sort.type === 'desc') {
                sortIcon = <i className="fas fa-sort-down" />;
                sortType = 'asc';
            } else {
                sortIcon = <i className="fas fa-sort-up" />;
                sortType = 'desc';
            }
        }

        return <div onClick={handleSort.bind(this, field, sortType)}>{label} {sortIcon}</div>
    };

    return (
        <div className="table-container">
            <table className="table table-sm table-hover table-striped">
                <thead>
                    <tr>
                        <th style={{ minWidth: 50 }}>
                            <span className="sort-column">{renderHeader('ID', 'id')}</span>
                        </th>
                        <th><span className="sort-column">{renderHeader('Date', 'created_at')}</span></th>
                        <th><span className="sort-column">{renderHeader('Last Response Date', 'last_response_date')}</span></th>
                        <th><span className="sort-column">{renderHeader('Customer Name', 'name')}</span></th>
                        <th><span className="sort-column">{renderHeader('Email', 'email')}</span></th>
                        <th><span className="sort-column">Help With</span></th>
                        <th><span className="sort-column">Attached Files</span></th>
                        <th><span className="sort-column">ACM Member</span></th>
                        <th><span className="sort-column">{renderHeader('Status', 'status')}</span></th>
                        <th style={{ width: 80 }}></th>
                    </tr>
                </thead>
                <tbody>{renderRequests()}</tbody>
            </table>
            <Pagination
                pagination={props.pagination}
                setActivePage={props.setActivePage}
            />
        </div>
    );
});

export default Table;
